<div
  *ngIf="notificationService.notificationType$ | async as notificationType"
  [ngClass]="{
    'active': notificationService.isNotificationShow$ | async,
    'error': notificationType === 'error',
    'warning': notificationType === 'warning',
    'success': notificationType === 'success'
  }"
  class="notification">

  <div class="notification__header">
    <ng-container *ngFor="let iconNum of icons">
      <img
      *ngIf="(notificationService.notificationIcon$| async) === iconNum"
      [src]="'assets/img/notification-' + iconNum.split('-')[1] + '.svg'"
      alt="Icon"
      class="notification__icon">
    </ng-container>

    <div class="notification__body">
        <h2 *ngIf="notificationService.notificationTitle$ | async as title" class="headline">
          {{ title | translate }}
        </h2>
        <ng-container *ngIf="notificationService.notificationDescription$ | async as desc">
          <p *ngIf="isString(desc); else arrayTemplate" class="description">
            {{ desc | translate }}
          </p>
        </ng-container>
    </div>

    <button (click)="hideNotification()" class="notification__close">
      <img
        src="assets/img/close-modal.svg"
        alt="Close icon"
        class="notification__close-icon">
    </button>
  </div>

  <div class="notification__progress-bar"   [ngClass]="{
    'error': notificationType === 'error',
    'warning': notificationType === 'warning',
    'success': notificationType === 'success'
  }"  [ngStyle]="{ width: progress + '%' }"></div>
</div>

<ng-template #arrayTemplate>
  <ng-container *ngIf="notificationService.notificationDescription$ | async as desc">
    <ng-container *ngIf="isArray(desc); else arrayTemplate">
      <p *ngFor="let descItem of desc" class="description">
        {{ descItem | translate }}
      </p>
    </ng-container>
  </ng-container>
</ng-template>
